import type {
  ClinicConversationMutation,
  ClinicMessageRecipient,
  ClinicMessageSource,
  CreateClinicConversation,
} from "@emr/contracts";

export type MessagePatient = { id: string; name: string; identity?: string };
export type MessageSeed = {
  patient?: MessagePatient;
  sources?: ClinicMessageSource[];
  request?: { encounterId?: string; resultId?: string; reportId?: string };
  body?: string;
};
export type MessageDraft = {
  patient: MessagePatient | null;
  sources: ClinicMessageSource[];
  recipients: ClinicMessageRecipient[];
  subject: string;
  body: string;
  task: boolean;
  owner: string;
  due: string;
  reviewedVersion?: number | undefined;
  pending?: CreateClinicConversation | ClinicConversationMutation | undefined;
};
// Deliberately session-only. Scope includes authenticated user, tenant, and site.
const drafts = new Map<string, MessageDraft>();
export const messageDraftKey = (scope: string, seed?: MessageSeed, conversationId?: string) =>
  `${scope}:${conversationId ? `reply:${conversationId}` : `new:${seed?.patient?.id ?? "clinic"}:${JSON.stringify(seed?.sources ?? [])}:${seed?.request ? "request" : "message"}`}`;
export function getMessageDraft(key: string, seed?: MessageSeed): MessageDraft {
  const existing = drafts.get(key);
  if (existing) return existing;
  const value: MessageDraft = {
    patient: seed?.patient ?? null,
    sources: seed?.sources ?? [],
    recipients: [],
    subject: "",
    body: seed?.body ?? "",
    task: Boolean(seed?.request),
    owner: "",
    due: "",
  };
  drafts.set(key, value);
  return value;
}
export function saveMessageDraft(key: string, value: MessageDraft) {
  drafts.set(key, value);
}
export function removeMessageDraft(key: string) {
  drafts.delete(key);
}
export function clearMessageDrafts() {
  drafts.clear();
}
